import { AliquotTax } from "../aliquot-tax";
import { Entity, Plan } from "../entity";

export class BudgetPlan {
  Entity: Entity;
  Plan: Plan
  AliquotTax: AliquotTax;
}
